import BlogGridView from "../../../commonComponents/blogGridView";

const BlogLayout1Container = () => {
  return <BlogGridView sectionClass="blog-layout-1" type="layout_1" side="no" carShow={10} />;
};

export default BlogLayout1Container;
